import {
  CONTACT_FORM_SENT,
  CONTACT_MODAL_CLOSED,
  CONTACT_MODAL_OPENED,
  NEWSLETTER_SIGNUP_SUCCESS,
  REBATE_TERMS_MODAL_CLOSED,
  REBATE_TERMS_MODAL_OPENED,
  WELCOME_MODAL_CLOSED,
  WELCOME_MODAL_OPENED,
  CONSULTATION_MODAL_CLOSED,
  CONSULTATION_MODAL_OPENED,
  TOUR_MODAL_CLOSED,
  TOUR_MODAL_OPENED
} from '../constants'

const initialState = {
  contactModalOpen: false,
  contactModalOptions: {},
  rebateTermsModalOpen: false,
  welcomeModalOpen: false,
  consultationModalOpen: false,
  tourModalOpen: false,
  tourModalOptions: {}
}

export default function(state = initialState, action) {
  switch (action.type) {
    case CONTACT_FORM_SENT:
      return {
        ...state,
        contactModalOpen: false,
        contactModalOptions: {}
      }
    case CONTACT_MODAL_CLOSED:
      return {
        ...state,
        contactModalOpen: false,
        contactModalOptions: {}
      }
    case CONTACT_MODAL_OPENED:
      return {
        ...state,
        contactModalOpen: true,
        contactModalOptions: action.options
      }
    case NEWSLETTER_SIGNUP_SUCCESS:
      return {
        ...state,
        welcomeModalOpen: false
      }
    case REBATE_TERMS_MODAL_CLOSED:
      return {
        ...state,
        rebateTermsModalOpen: false
      }
    case REBATE_TERMS_MODAL_OPENED:
      return {
        ...state,
        rebateTermsModalOpen: true
      }
    case WELCOME_MODAL_CLOSED:
      return {
        ...state,
        welcomeModalOpen: false
      }
    case WELCOME_MODAL_OPENED:
      return {
        ...state,
        welcomeModalOpen: true
      }
    case CONSULTATION_MODAL_CLOSED:
      return {
        ...state,
        consultationModalOpen: false
      }
    case CONSULTATION_MODAL_OPENED:
      return {
        ...state,
        consultationModalOpen: true
      }
    case TOUR_MODAL_CLOSED:
      return {
        ...state,
        tourModalOpen: false
      }
    case TOUR_MODAL_OPENED:
      return {
        ...state,
        tourModalOpen: true,
        tourModalOptions: action.options
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modals.js